import { FlexBox, FInter, Colors, useBreakpoint } from '@brg/ui';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { LayoutConst } from 'core/modules';
import { MoreButton } from 'shared/components/more-button';
import ShrinkIcon from './ShrinkIcon';
import { TagsRightShadow } from "../../_competition/pages/AllCompetitionsPage/styled";
import { AppTester } from 'supporting';
import ArrowTopRightIcon from "./ArrowTopRightIcon";
import ShrinkIconBold from "./ShrinkIconBold";
import { useRouteMatch } from 'react-router-dom';

const Text = styled(FInter.SmallTextBoldMagic)<{ isCompetition?: boolean, isShort?: boolean, mobileShrink?: boolean, fullLineText?: boolean }>`
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  ${({ fullLineText }) => fullLineText && css`
    text-overflow: ellipsis;
    white-space: nowrap;
  `};
  display: inline-block;
  white-space: pre;
  overflow: hidden;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    font-size: 15px;
    line-height: 20px;
  }

    // @media(max-width: ${LayoutConst.screen.l_12}px) {
  //     font-size: 13px;
  //     line-height: 18px;
  // }

  ${({ isCompetition }) => isCompetition ? css`
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-size: 15px;
      line-height: 20px;
      font-weight: 600;
    }
  ` : null};

  ${({ mobileShrink }) => mobileShrink ? css`
    // @media (max-width: ${LayoutConst.screen.sm}px) {
    //   max-width: ${(window.innerWidth - 262) / window.innerWidth * 100}vw;
    // }

    // @media (max-width: 430px) {
    //   max-width: ${(window.innerWidth - 190) / window.innerWidth * 100}vw;
    // }
  ` : null}

  ${({ isShort }) => isShort ? css`
    @media (max-width: 450px) {
      position: relative;
      max-width: 145px;
      justify-content: flex-start;
    }
    @media (max-width: 400px) {
      max-width: calc((70px + (130 - 70) * ((100vw - 320px) / (400 - 320))) * 1);
    }
  ` : null};
`;

const Wrapper = styled(FlexBox)<{ isShrimpIcon?: boolean, isCompetition?: boolean, mobileShrink?: boolean }>`
  place-items: center;
  cursor: pointer;
  margin-right: 9px;
  @media (max-width: ${LayoutConst.screen.l}px) {
    width: fit-content;
    margin-right: 0;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-grow: 1;
    margin-right: 9px;
    // width: 100%;
    max-height: 100%;

    ${({ mobileShrink }) => mobileShrink && css`
      svg {
        z-index: 2;
      }
    `};
  }

  &:hover {
    ${Text} {
      color: ${({
        theme,
        isCompetition
      }) => isCompetition ? theme.competition.mainText : theme.arrowWithText.hover.text.color};
      transition: 0.2s all;
    }

    svg path {
      fill: ${({
        theme,
        isCompetition
      }) => isCompetition ? theme.competition.mainText : theme.arrowWithText.hover.svg.fill} !important;
      transition: 0.2s all;
    }
  }
`;

type PropsT = {
  text: string;
  fill?: string;
  active?: boolean;
  onClick?: () => void;
  hideIcon?: boolean;
  shrimpIcon?: boolean;
  arrowIcon?: boolean;
  arrowBoldIcon?: boolean;
  isCompetition?: boolean;
  isShort?: boolean;
  mobileShrink?: boolean;
  isMap?: boolean;
  hideGradient?: boolean
  newColorStyle?: boolean
  isSuperPuperGames?: boolean
  fullLineText?: boolean
  importantColor?: string
  projectsLength?: number | string
};

const ArrowTopIconWithText: FC<PropsT> = ({
  text,
  importantColor,
  onClick,
  arrowBoldIcon,
  fill = 'currentColor',
  isCompetition,
  active,
  newColorStyle,
  hideIcon,
  shrimpIcon,
  arrowIcon,
  isShort,
  fullLineText,
  mobileShrink,
  isMap,
  hideGradient,
  projectsLength,
  isSuperPuperGames
}) => {
  const theme = useTheme();
  const listRef = useRef<HTMLDivElement>(null);
  const textREf = useRef<string | null>(null);
  const [textWidth, setTextWidth] = useState(0);
  const is1200BP = useBreakpoint(1200);
  const is375BP = useBreakpoint(375);
  const is450BP = useBreakpoint(450);
  const is568BP = useBreakpoint(LayoutConst.screen.sm);
  const [gradientVisible, setGradientVisible] = useState(false);
  const isDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCompetitionPage = !!useRouteMatch('/awards');
  const isMapPage = useRouteMatch('/map')
  const isDezignCompetition = AppTester.isCompetition()
  const isMediiia = AppTester.isMediiia()

  const isHseCompetition = useMemo(
    () => ((isHSEDesign && isCompetitionPage) || isDezignCompetition)
    , [isHSEDesign, isDezignCompetition, isCompetitionPage])

  const outerWidth = useMemo(() => window.outerWidth, [])

  useEffect(() => {
    if (textREf.current !== text && is568BP) {
      const maxPercentWidth = (outerWidth / 100) * 32
      setGradientVisible((listRef?.current?.clientWidth || 0 ) >= maxPercentWidth)
    }
    textREf.current = text;
  } , [textREf, text, textREf.current, listRef?.current, listRef, outerWidth, active, is568BP])

  const color = useMemo(() => {
    return active ? (isCompetition ? theme.competition.mainText :
        (newColorStyle ? theme.designerPage.sliderDropdownColor : Colors.galBlack100)) :
      (isCompetition ? theme.competition.secondaryText : Colors.galBlack47)

  }, [active, isCompetition, newColorStyle, theme])

  const arrowPadding = {
    marginRight: '4px',
    paddingRight: '5px',
    display: 'flex',
    alignItems: 'center'
  } 
  
  return <Wrapper ref={listRef} mobileShrink={mobileShrink} offsetRightMobile={mobileShrink ? 24 : 0} direction='row'
                  className={'target-icon-wrapper'} isShrimpIcon={shrimpIcon}
                  onClick={() => onClick ? onClick() : false} isCompetition={isCompetition}>
    <Text
      className={'dropdown-header icon-with-text'}
      color={importantColor || color}
      justify="center"
      align="center"
      style={{
       ...(!hideIcon ? arrowPadding : {}),
        ...(isDafes ? { color: isMap ? '#909090' : (importantColor || '#151514') } : {})
      }}
      isShort={isShort}
      isCompetition={isCompetition}
      mobileShrink={mobileShrink}
      fullLineText={fullLineText}
      // hoverColor={Colors.galBlack100}
    >
      {isMapPage && !is1200BP  ? (
        <span style={{
          display: 'inline-block',
          maxWidth: '120px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {text}
        </span>
      ) : (
        <span>{text}</span>
      )}
      <span>{projectsLength || projectsLength === 0 ? `  |  ${projectsLength}` : ''}</span>
    </Text>
    {!hideIcon && (
      <>
        {shrimpIcon ? (
          <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 8.36851L1.69486 3.9176C1.47871 3.69413 1.12826 3.69413 0.912111 3.91761C0.695961 4.14108 0.695963 4.5034 0.912115 4.72687L5.60863 9.5824C5.82478 9.80587 6.17522 9.80587 6.39137 9.5824L11.0879 4.72687C11.304 4.5034 11.304 4.14108 11.0879 3.91761C10.8717 3.69413 10.5213 3.69413 10.3051 3.9176L6 8.36851Z"
              fill={color}/>
          </svg>
        ) : arrowIcon ? <ShrinkIcon/> : arrowBoldIcon ? <ShrinkIconBold/> : <MoreButton/>}
      </>
    )}
    {
      !hideGradient && 
        mobileShrink && gradientVisible &&
      <TagsRightShadow isHseCompetition={isHseCompetition} className={'dropdown-shadow'} mobileShrink={mobileShrink} isMediiia={isMediiia} isSuperPuperGames={isSuperPuperGames}/>
    }
  </Wrapper>
};

export default ArrowTopIconWithText;
import { FlexBox, FInter, Colors, useBreakpoint } from '@brg/ui';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { LayoutConst } from 'core/modules';
import { MoreButton } from 'shared/components/more-button';
import ShrinkIcon from './ShrinkIcon';
import { TagsRightShadow } from "../../_competition/pages/AllCompetitionsPage/styled";
import { AppTester } from 'supporting';
import ArrowTopRightIcon from "./ArrowTopRightIcon";
import ShrinkIconBold from "./ShrinkIconBold";
import { useRouteMatch } from 'react-router-dom';

const Text = styled(FInter.SmallTextBoldMagic)<{ isCompetition?: boolean, isShort?: boolean, mobileShrink?: boolean, fullLineText?: boolean }>`
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  ${({ fullLineText }) => fullLineText && css`
    text-overflow: ellipsis;
    white-space: nowrap;
  `};
  display: inline-block;
  white-space: pre;
  overflow: hidden;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    font-size: 15px;
    line-height: 20px;
  }

    // @media(max-width: ${LayoutConst.screen.l_12}px) {
  //     font-size: 13px;
  //     line-height: 18px;
  // }

  ${({ isCompetition }) => isCompetition ? css`
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-size: 15px;
      line-height: 20px;
      font-weight: 600;
    }
  ` : null};

  ${({ mobileShrink }) => mobileShrink ? css`
    // @media (max-width: ${LayoutConst.screen.sm}px) {
    //   max-width: ${(window.innerWidth - 262) / window.innerWidth * 100}vw;
    // }

    // @media (max-width: 430px) {
    //   max-width: ${(window.innerWidth - 190) / window.innerWidth * 100}vw;
    // }
  ` : null}

  ${({ isShort }) => isShort ? css`
    @media (max-width: 450px) {
      position: relative;
      max-width: 145px;
      justify-content: flex-start;
    }
    @media (max-width: 400px) {
      max-width: calc((70px + (130 - 70) * ((100vw - 320px) / (400 - 320))) * 1);
    }
  ` : null};
`;

const Wrapper = styled(FlexBox)<{ isShrimpIcon?: boolean, isCompetition?: boolean, mobileShrink?: boolean }>`
  place-items: center;
  cursor: pointer;
  margin-right: 9px;
  @media (max-width: ${LayoutConst.screen.l}px) {
    width: fit-content;
    margin-right: 0;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-grow: 1;
    margin-right: 9px;
    // width: 100%;
    max-height: 100%;

    ${({ mobileShrink }) => mobileShrink && css`
      svg {
        z-index: 2;
      }
    `};
  }

  &:hover {
    ${Text} {
      color: ${({
        theme,
        isCompetition
      }) => isCompetition ? theme.competition.mainText : theme.arrowWithText.hover.text.color};
      transition: 0.2s all;
    }

    svg path {
      fill: ${({
        theme,
        isCompetition
      }) => isCompetition ? theme.competition.mainText : theme.arrowWithText.hover.svg.fill} !important;
      transition: 0.2s all;
    }
  }
`;

type PropsT = {
  text: string;
  fill?: string;
  active?: boolean;
  onClick?: () => void;
  hideIcon?: boolean;
  shrimpIcon?: boolean;
  arrowIcon?: boolean;
  arrowBoldIcon?: boolean;
  isCompetition?: boolean;
  isShort?: boolean;
  mobileShrink?: boolean;
  isMap?: boolean;
  hideGradient?: boolean
  newColorStyle?: boolean
  isSuperPuperGames?: boolean
  fullLineText?: boolean
  importantColor?: string
  projectsLength?: number | string
};

const ArrowTopIconWithText: FC<PropsT> = ({
  text,
  importantColor,
  onClick,
  arrowBoldIcon,
  fill = 'currentColor',
  isCompetition,
  active,
  newColorStyle,
  hideIcon,
  shrimpIcon,
  arrowIcon,
  isShort,
  fullLineText,
  mobileShrink,
  isMap,
  hideGradient,
  projectsLength,
  isSuperPuperGames
}) => {
  const theme = useTheme();
  const listRef = useRef<HTMLDivElement>(null);
  const textREf = useRef<string | null>(null);
  const [textWidth, setTextWidth] = useState(0);
  const is1200BP = useBreakpoint(1200);
  const is375BP = useBreakpoint(375);
  const is450BP = useBreakpoint(450);
  const is568BP = useBreakpoint(LayoutConst.screen.sm);
  const [gradientVisible, setGradientVisible] = useState(false);
  const isDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCompetitionPage = !!useRouteMatch('/awards');
  const isMapPage = useRouteMatch('/map')
  const isDezignCompetition = AppTester.isCompetition()
  const isMediiia = AppTester.isMediiia()

  const isHseCompetition = useMemo(
    () => ((isHSEDesign && isCompetitionPage) || isDezignCompetition)
    , [isHSEDesign, isDezignCompetition, isCompetitionPage])

  const outerWidth = useMemo(() => window.outerWidth, [])

  useEffect(() => {
    if (textREf.current !== text && is568BP) {
      const maxPercentWidth = (outerWidth / 100) * 32
      setGradientVisible((listRef?.current?.clientWidth || 0 ) >= maxPercentWidth)
    }
    textREf.current = text;
  } , [textREf, text, textREf.current, listRef?.current, listRef, outerWidth, active, is568BP])

  const color = useMemo(() => {
    return active ? (isCompetition ? theme.competition.mainText :
        (newColorStyle ? theme.designerPage.sliderDropdownColor : Colors.galBlack100)) :
      (isCompetition ? theme.competition.secondaryText : Colors.galBlack47)

  }, [active, isCompetition, newColorStyle, theme])

  const arrowPadding = {
    marginRight: '4px',
    paddingRight: '5px',
    display: 'flex',
    alignItems: 'center'
  } 
  
  return <Wrapper ref={listRef} mobileShrink={mobileShrink} offsetRightMobile={mobileShrink ? 24 : 0} direction='row'
                  className={'target-icon-wrapper'} isShrimpIcon={shrimpIcon}
                  onClick={() => onClick ? onClick() : false} isCompetition={isCompetition}>
    <Text
      className={'dropdown-header icon-with-text'}
      color={importantColor || color}
      justify="center"
      align="center"
      style={{
       ...(!hideIcon ? arrowPadding : {}),
        ...(isDafes ? { color: isMap ? '#909090' : (importantColor || '#151514') } : {})
      }}
      isShort={isShort}
      isCompetition={isCompetition}
      mobileShrink={mobileShrink}
      fullLineText={fullLineText}
      // hoverColor={Colors.galBlack100}
    >
      {isMapPage && !is1200BP  ? (
        <span style={{
          display: 'inline-block',
          maxWidth: '120px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {text}
        </span>
      ) : (
        <span>{text}</span>
      )}
      <span>{projectsLength || projectsLength === 0 ? `  |  ${projectsLength}` : ''}</span>
    </Text>
    {!hideIcon && (
      <>
        {shrimpIcon ? (
          <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 8.36851L1.69486 3.9176C1.47871 3.69413 1.12826 3.69413 0.912111 3.91761C0.695961 4.14108 0.695963 4.5034 0.912115 4.72687L5.60863 9.5824C5.82478 9.80587 6.17522 9.80587 6.39137 9.5824L11.0879 4.72687C11.304 4.5034 11.304 4.14108 11.0879 3.91761C10.8717 3.69413 10.5213 3.69413 10.3051 3.9176L6 8.36851Z"
              fill={color}/>
          </svg>
        ) : arrowIcon ? <ShrinkIcon/> : arrowBoldIcon ? <ShrinkIconBold/> : <MoreButton/>}
      </>
    )}
    {
      !hideGradient && 
        mobileShrink && gradientVisible &&
      <TagsRightShadow isHseCompetition={isHseCompetition} className={'dropdown-shadow'} mobileShrink={mobileShrink} isMediiia={isMediiia} isSuperPuperGames={isSuperPuperGames}/>
    }
  </Wrapper>
};

export default ArrowTopIconWithText;
